export default {"src":"/_next/static/media/zod.7b2b06a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};